export default __webpack_public_path__ + "static/natalia-dulepa-4e842887e45ae79982a7895f1d410e5b.png";